<template>
    <div class="variant-overlay" @click.self="$emit('close')">
        <div class="variant-modal">
            <button class="modal-close" @click="$emit('close')">✕</button>

            <div class="modal-img-wrap d-flex justify-content-center">
                <img :src="product.image" :alt="product.name" class="modal-product-img">
            </div>

            <h3 class="modal-title text-center">{{ product.name }}</h3>
            <p class="modal-subtitle text-center">Elige tu variante</p>

            <div class="variant-options d-flex justify-content-center gap-3 mt-3">
                <div
                    class="variant-option d-flex flex-column align-items-center"
                    :class="{ active: selected === 'normal' }"
                    @click="selected = 'normal'"
                    role="button"
                >
                    <div class="variant-icon">🍗</div>
                    <span class="variant-name">Normal</span>
                </div>

                <div
                    class="variant-option d-flex flex-column align-items-center"
                    :class="{ active: selected === 'spicy' }"
                    @click="selected = 'spicy'"
                    role="button"
                >
                    <div class="variant-icon">🌶️</div>
                    <span class="variant-name">Spicy</span>
                </div>
            </div>

            <button class="btn-confirm w-100 mt-4" @click="$emit('confirm', selected)">
                Agregar al tercio
            </button>
        </div>
    </div>
</template>

<script>
export default {
    name: 'VariantModal',
    emits: ['confirm', 'close'],
    props: {
        product: { type: Object, required: true },
    },
    data() {
        return {
            selected: 'normal',
        };
    },
};
</script>

<style scoped>
.variant-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: rgba(0, 0, 0, 0.6);
    z-index: 5000;
    display: flex;
    align-items: flex-end;
    justify-content: center;
    animation: fadeIn 0.2s ease;
}

@keyframes fadeIn {
    0% { opacity: 0; }
    100% { opacity: 1; }
}

.variant-modal {
    width: 100%;
    max-width: 420px;
    background: #fff;
    border-radius: 24px 24px 0 0;
    padding: 24px 24px 32px;
    position: relative;
    animation: slideUp 0.3s ease;
}

@keyframes slideUp {
    0% { transform: translateY(100%); }
    100% { transform: translateY(0); }
}

.modal-close {
    position: absolute;
    top: 16px;
    right: 16px;
    width: 32px;
    height: 32px;
    border-radius: 50%;
    border: none;
    background: var(--octagenary);
    color: var(--text9);
    font-size: 14px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
}

.modal-img-wrap {
    margin-bottom: 12px;
}

.modal-product-img {
    height: 80px;
    object-fit: contain;
    filter: drop-shadow(0 4px 8px rgba(0, 0, 0, 0.15));
}

.modal-title {
    font-size: 22px;
    font-weight: 700;
    color: var(--text3);
    margin: 0;
}

.modal-subtitle {
    font-size: 14px;
    color: var(--text11);
    margin: 4px 0 0;
}

.variant-option {
    width: 120px;
    padding: 16px 12px;
    border-radius: 14px;
    border: 2px solid var(--nonagenary);
    cursor: pointer;
    transition: all 0.2s ease;
    background: #fff;
}

.variant-option:hover {
    border-color: var(--primary);
}

.variant-option.active {
    border-color: var(--primary);
    background: rgba(232, 118, 43, 0.06);
    box-shadow: 0 0 0 3px rgba(232, 118, 43, 0.15);
}

.variant-icon {
    font-size: 32px;
    margin-bottom: 6px;
}

.variant-name {
    font-size: 14px;
    font-weight: 700;
    color: var(--text6);
}

.btn-confirm {
    padding: 14px;
    border: none;
    border-radius: 14px;
    background: var(--primary);
    color: #fff;
    font-size: 16px;
    font-weight: 700;
    cursor: pointer;
    transition: all 0.2s ease;
}

.btn-confirm:hover {
    background: var(--vigequinary);
}

.btn-confirm:active {
    transform: scale(0.98);
}
</style>
